import { graphql, Link } from 'gatsby'
import React from 'react'
import get from 'lodash/get'
import ContactUs from 'components/contactUs'
import CustomerSpeaks from 'components/customerSpeaks'
import FaqsRoofing from 'components/faqsRoofing'
import Meta from 'components/meta'
import Modal from 'react-modal'
import Layout from 'components/layout'
import ReactWOW from 'react-wow'
import Img from 'gatsby-image'
import GooglePlacesAutocomplete from 'react-google-places-autocomplete'
import 'react-google-places-autocomplete/dist/assets/index.css'
import Geocode from 'react-geocode'
Geocode.setApiKey('AIzaSyBzQI_X64FiQPXJX7AQZBc19J-JL9FlZuw')

class RoofPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsOpen: false,
      classActive: 1,
      address: '',
      lat: '',
      lng: '',
      city: '',
      state: '',
      polygonPoints: [],
      zip: '',
      loading: false,
      enable: false,
      errMsg: '',
    }
  }

  openModel = event => {
    event.preventDefault()
    this.setState({ modalIsOpen: true })
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false })
  }

  onClassClick = (event, type) => {
    this.setState({ classActive: type })
  }

  getEstimate = e => {
    this.setState({ loading: true, errMsg: '' })
    e.preventDefault()
    fetch(
      `https://infinity-api.expansionjs.com?lat=${this.state.lat}&lng=${this.state.lng}`,
      {
        method: 'GET',
        headers: {
          accept: 'application/json',
        },
      }
    )
      .then(response => response.json())
      .then(data => {
        this.setState({ loading: false })
        if (data) {
          const polygonPoints = data;
          this.setState({ polygonPoints, enable: true })
          this.props.navigate('/roofing-step', { state: this.state })
        } else {
          this.setState({
            enable: false,
            errMsg: data.status && data.status.msg == 'SuccessWithoutResult' ? 'No data found for this address.' : data.status.msg,
          })
        }
      })
  }

  onAddressClick = event => {
    this.setState({ errMsg: '' })
    Geocode.fromAddress(event.description).then(
      response => {
        const { lat, lng } = response.results[0].geometry.location
        this.setState({
          address: event.description,
          lat: lat,
          lng: lng,
          enable: true,
        })
        Geocode.fromLatLng(lat, lng).then(
          res => {
            res.results[0].address_components.forEach(element => {
              if (element.types[0] == 'locality') {
                this.setState({ city: element.long_name })
              }
              if (element.types[0] == 'administrative_area_level_1') {
                this.setState({ state: element.long_name })
              }
              if (element.types[0] == 'postal_code') {
                this.setState({ zip: element.long_name })
              }
            })
          },
          error => {
            console.error(error)
          }
        )
      },
      error => {
        console.error(error)
      }
    )
  }

  componentDidUpdate() { }

  render() {
    const { location, data } = this.props
    const pageData = get(data, 'contentfulRoofingPage')
    const customStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '760px',
      },
    }
    return (
      <Layout location={location}>
        <Meta site={get(data, 'contentfulPagesSeo')} />
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel=""
          style={customStyles}
          ariaHideApp={false}
        >
          <div className="zoom-anim-dialog embed-responsive embed-responsive-16by9">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/VBtuyxKtlm4"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullscreen
            ></iframe>
          </div>
        </Modal>

        <div className="wrapper inner-page">
          <div
            className="page-banner masked parallax-inner parallax-section roofing-bnr"
            data-parallax="1"
            style={{
              background: `url(${pageData.bannerImage.file.url}) center no-repeat`,
            }}
          >
            <div className="inner-continer">
              <div className="row">
                <div className="col-md-12 col-lg-9 pd-0 m-auto">
                  <div className="title-info text-white text-center roofing-title">
                    <h1 className="display-1 text-white">
                      <span className="infity-color">
                        {pageData.bannerHeading1}
                      </span>
                      <span className="fontWeight-Regular">
                        {' '}
                        {pageData.bannerHeading2}
                      </span>{' '}
                      {pageData.bannerHeading3}
                    </h1>
                  </div>
                  <div className="text-center roofing-form-wrap">
                    <h5 className="mb-3 text-white">
                      {pageData.bannerSubHeading}
                    </h5>
                    <div className="roofing-form-section">
                      <form className="d-flex flex-row align-items-center justify-content-start">
                        <div className="input-group mb-0">
                          <div className="input-group-prepend icon-form">
                            <i
                              className="fa fa-map-marker"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="google-autoComplete">
                            <GooglePlacesAutocomplete
                              autocompletionRequest={{
                                componentRestrictions: {
                                  country: 'us',
                                },
                              }}
                              onSelect={this.onAddressClick}
                            />
                          </div>
                        </div>
                        <button
                          onClick={e => this.getEstimate(e)}
                          disabled={
                            this.state.enable && this.state.address
                              ? false
                              : true
                          }
                          className={
                            this.state.loading
                              ? 'btn btn-outline-secondary btn-loader'
                              : 'btn btn-outline-secondary'
                          }
                        >
                          {this.state.loading ? '' : pageData.bannerButtonText}
                        </button>
                      </form>
                    </div>
                    <div style={{ color: '#c42a2a' }}>
                      {this.state.errMsg}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="page-content page-content-space">
            <div className="container-fluid">
              <div className="container container-roofing">
                <div className="row">
                  <div className="col-12 text-center">
                    <h2 className="ttl-mr roofing_title">
                      All <span className="infity-color">Roofing</span>
                    </h2>
                  </div>
                </div>
                <div className="row roofing-contentBox">
                  {pageData.globalContent.map((item, index) => {
                    return (
                      <div className="col-md-6 col-sm-6 col-lg-3" key={index}>
                        <div className="roofing-Thumbnail-wrap">
                          <div className="roofing-Thumbnail-img">
                            <Img
                              fluid={item.image.fluid}
                              alt={
                                item.image.description
                                  ? item.image.description
                                  : ''
                              }
                              className="about-img img-responsive"
                            />
                          </div>
                          <div className="roofing-Thumbnail-content text-center">
                            <h4 className="mt-2 mb-4 fontWeight-Regular">
                              {item.heading}
                            </h4>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
                <div className="empty-space col-xs-b35 col-md-b70"></div>
              </div>
            </div>

            <div className="infinity_roofing-section bg-light-color container-fluid">
              <div className="row">
                <ReactWOW animation="fadeInLeft" duration=".75s">
                  <div className="col-md-6 roofing-product-content">
                    <div className="roofing-prodct-content_wrap">
                      <h2 className="ttl-mr">
                        Infinity <span className="infity-color">Roofing</span>
                      </h2>

                      <div className="roofing-product-info-wrap">
                        <div
                          className={
                            'roofing-product-info ' +
                            (this.state.classActive == 1 ? 'active' : '')
                          }
                        >
                          <div
                            className="roofing-product-icon"
                            onClick={event => this.onClassClick(event, 1)}
                          >
                            <img
                              alt=""
                              className="about-img img-responsive"
                              src="/images/roofing/rp-w.png"
                            />
                          </div>
                          <h4 className="mt-3 mb-2">Roofing Product</h4>
                          <p>
                            We will provide you an estimate & identify the most
                            cost-effective roofing solution that makes sense and
                            will only recommend a complete roofing process. Our
                            team strives to take care of every aspect of any
                            project we undertake so you can have peace of mind
                            while we’re working on a project
                          </p>
                        </div>
                        <div
                          className={
                            'roofing-product-info ' +
                            (this.state.classActive == 2 ? 'active' : '')
                          }
                        >
                          <div
                            className="roofing-product-icon"
                            onClick={event => this.onClassClick(event, 2)}
                          >
                            <img
                              alt=""
                              className="about-img img-responsive"
                              src="/images/roofing/rf-w.png"
                            />
                          </div>
                          <h4 className="mt-3 mb-2">Roof Financing</h4>
                          <p>
                            If you’re in a hurry, a roofing loan can be a great
                            financing option for a new roof. Roofing have always
                            taken our customers’ convenience and comfort into
                            consideration. That’s why we’re happy to offer our
                            customers an affordable way to get their roof
                            repaired or replaced on time.
                          </p>
                        </div>
                        <div
                          className={
                            'roofing-product-info ' +
                            (this.state.classActive == 3 ? 'active' : '')
                          }
                        >
                          <div
                            className="roofing-product-icon"
                            onClick={event => this.onClassClick(event, 3)}
                          >
                            <img
                              alt=""
                              className="about-img img-responsive"
                              src="/images/roofing/inf-app-w.png"
                            />
                          </div>
                          <h4 className="mt-3 mb-2">Infinity Application</h4>
                          <p>
                            Online roof measuring & estimating tools that allows
                            roofing contractors and home owners to accurately
                            analyze and estimate the area of a roof, as well as
                            the amount of materials.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </ReactWOW>
                <ReactWOW animation="fadeInRight" duration=".75s">
                  <div
                    className={
                      'col-md-6 roofing-product-img ' +
                      (this.state.classActive == 1
                        ? 'rf-product'
                        : this.state.classActive == 2
                          ? 'rf-financing'
                          : 'infinity-app')
                    }
                  >
                    <img
                      src="/images/roofing/img-roof.png"
                      className="about-img img-responsive"
                    />
                  </div>
                </ReactWOW>
              </div>
            </div>

            <div className="roofing_faqs-section bg-white container-fluid grey-bg">
              <div className="container">
                <FaqsRoofing />
              </div>
            </div>

            <div className="roof-getEstimate-section">
              <div className="row">
                <ReactWOW animation="fadeInLeft" duration=".75s">
                  <div className="col-md-6 roof-map-img">
                    <img
                      src="/images/roofing/map.png"
                      className="about-img img-responsive"
                    />
                  </div>
                </ReactWOW>
                <ReactWOW animation="fadeInRight" duration=".75s">
                  <div className="col-md-6 roofMap-howitWorks-content">
                    <h2 className="ttl-mr roofing-product-title">
                      How it <span className="infity-color">Works</span>
                    </h2>

                    <div className="roofing-product-info-wrap">
                      <div className="roofing-product-info roofMap-estimate-info">
                        <p className="mb-4">
                          All of your installers are fully insured and carry
                          workers compensation.
                        </p>
                        <div className="roofing-howitWork-content">
                          <p>
                            Get a no obligation roofing estimate for free in
                            seconds, and get matched with one of our vetted
                            contractors to do the work.
                          </p>
                          <p>
                            Infinity Roofing will help compare roofing quotes,
                            and and ensure you get the right roofing system.
                          </p>
                        </div>
                        <div className="roofing-works-btn d-flex justify-content-start">
                          <button className="btn-border btn our-guarantee-btn">
                            Our Guarantee
                          </button>
                          {/* <button
                            className="btn our-guarantee-btn watch-video-btn"
                            onClick={this.openModel}
                          >
                            <span className="video-playIcon">
                              <i
                                className="ion ion-play infity-color"
                                aria-hidden="true"
                              />
                            </span>{' '}
                            Watch Video
                          </button> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </ReactWOW>
              </div>
            </div>
          </div>

          <CustomerSpeaks
            list={get(data, 'allContentfulPagesCustomerReviews.nodes')}
          />
          <ContactUs location={location} />
        </div>
      </Layout>
    )
  }
}

export default RoofPage

export const query = graphql`
  {
    contentfulPagesSeo(pageName: { eq: "Roofing" }) {
      pageTitle
      pageName
      otherScripts {
        otherScripts
      }
      otherMetaTags {
        otherMetaTags
      }
      metaTagUrl
      metaTagTitle
      metaTagDescription
    }
    allContentfulPagesCustomerReviews {
      nodes {
        title
        shortDescription
        personRole
        personName
        longDescription {
          longDescription
        }
      }
    }
    contentfulRoofingPage(
      globalContent: { elemMatch: { pageName: { eq: "Roofing" } } }
    ) {
      bannerHeading1
      bannerHeading2
      bannerHeading3
      bannerSubHeading
      bannerButtonText
      bannerImage {
        file {
          url
        }
      }
      globalContent {
        pageName
        heading
        image {
          description
          fluid {
            src
            aspectRatio
            sizes
            srcSet
          }
        }
      }
    }
  }
`
